import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Loading from "../utils/loading/Loading";
const queryString = require("query-string");

import { emailVarificationRequest } from "./actions";

class EmailVarification extends Component {
  static propTypes = {
    emailVarificationRequest: PropTypes.func.isRequired,
    "email-varification": PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
      error: PropTypes.bool.isRequired,
    }).isRequired,
    location: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  requestmethod() {
    const accessToken = queryString.parse(this.props.location.search);
    console.log(accessToken.uid, accessToken.token);
    this.props.emailVarificationRequest({
      uid: accessToken.uid,
      token: accessToken.token,
    });
    // Active event fb
    switch (localStorage.getItem("autoSelectedPlan")) {
      case "basic":
        fbq("track", "StartTrial", {
          value: "39",
          currency: "EUR",
          predicted_ltv: "0.00",
        });
        console.log("EVENT BASIC");
        break;
      case "premium":
        fbq("track", "StartTrial", {
          value: "69",
          currency: "EUR",
          predicted_ltv: "0.00",
        });
        console.log("EVENT PREMIUM");
        break;
      case "tv":
        fbq("track", "StartTrial", {
          value: "89",
          currency: "EUR",
          predicted_ltv: "0.00",
        });
        console.log("EVENT TV");
        break;
      default:
        fbq("track", "StartTrial", {
          value: "39,00",
          currency: "EUR",
          predicted_ltv: "0.00",
        });
        console.log("EVENT TRACK FB 39,00");
        console.log(
          "Sorry, we are out of " + localStorage.getItem("autoSelectedPlan")
        );
    }
  }

  render() {
    const {
      "email-varification": { requesting, successful, error },
    } = this.props;

    return (
      <div>
        {requesting && <Loading size={80} />}
        {!requesting && !successful && !error && (
          <Loading size={80}>{this.requestmethod()}</Loading>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  "email-varification": state["email-varification"],
});

// eslint-disable-next-line max-len
const ConnectedPasswordRecovery = connect(mapStateToProps, {
  emailVarificationRequest,
})(EmailVarification);

export default ConnectedPasswordRecovery;



// WEBPACK FOOTER //
// ./src/pages/confirmemail/EmailVarification.jsx